var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagoneLightReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.941,
    height: 242.941,
    viewBox: "0 0 242.941 242.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242.941,
    height: 242.941,
    rx: 55.382,
    ry: 55.382,
    fill: "#b1b1b1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.404,67.856c-.46-.69-1.05-1.28-1.69-1.69-8.37-7.93-19.32-12.3-30.84-12.3-12,0-23.27,4.66-31.72,13.11l-35.65,35.64c-9.29,9.3-14.4,21.65-14.4,34.78v34.53l-15.06,15.05c-1.17,1.12-1.83,2.63-1.86,4.25-.03,1.61.56,3.15,1.68,4.31,1.19,1.24,2.78,1.86,4.37,1.86,1.51,0,3.02-.56,4.19-1.68l15.24-15.23h34.52c13.14,0,25.49-5.12,34.78-14.41l10.47-10.47c.39-.3.74-.65,1.04-1.04l22.54-22.54c.39-.3.74-.65,1.05-1.05l.54-.54c6.67-6.67,10.99-15.17,12.5-24.58.32-.84.45-1.76.38-2.66,1.3-13-3.1-25.87-12.08-35.34ZM163.514,97.626l17.39-17.38c3.57,5.18,5.54,11.15,5.75,17.38h-23.14ZM84.204,137.396c0-9.9,3.86-19.21,10.86-26.22l35.65-35.64c6.21-6.21,14.43-9.63,23.16-9.63,6.62,0,12.98,1.99,18.47,5.77l-27.24,27.25c-.39.3-.74.65-1.05,1.04l-22.54,22.54c-.39.3-.74.66-1.04,1.04l-22.54,22.54c-.39.31-.74.66-1.04,1.05l-12.69,12.68v-22.42ZM141.404,157.516c-7,7-16.32,10.86-26.22,10.86h-22.42l11.48-11.47h37.77l-.61.61ZM154.124,144.796h-37.77l11.47-11.48h37.78l-11.48,11.48ZM177.664,121.216h-37.73l11.47-11.48h33.34c-1.53,4.28-3.91,8.13-7.08,11.48Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagoneLightReady);
export default __webpack_public_path__ + "static/media/hexagone-light-ready.4e462fe61d461c93a80e2f30689e0652.svg";
export { ForwardRef as ReactComponent };